import { render, staticRenderFns } from "./NationalDay2020.vue?vue&type=template&id=90c205f4&scoped=true&"
import script from "./NationalDay2020.vue?vue&type=script&lang=js&"
export * from "./NationalDay2020.vue?vue&type=script&lang=js&"
import style0 from "./NationalDay2020.vue?vue&type=style&index=0&id=90c205f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c205f4",
  null
  
)

export default component.exports